import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable, of } from 'rxjs';
import { DispatchesCanceled } from './../models';
@Injectable({
  providedIn: 'root'
})
export class DispatchesCanceledService {

  constructor(
    public apiService: ApiService
  ) { }

  getDispatchesCanceled(request): Observable<DispatchesCanceled[]> {
    return this.apiService
    .post(`${this.apiService.cancellation}/cancellations`, request);
  }

  updateStateDispatch(body): Observable<DispatchesCanceled[]> {
    return this.apiService
    .put(`${this.apiService.cancellation}/cancellations`, body);
  }
}
